<script lang="ts">
	import type { Device } from 'src/types/Device';
	import CloudRecordings from './CloudRecordings.svelte';
	import { routeToDeviceSettings } from 'src/stores/ui/route-to-device-settings';
	import MediaPreview from './MediaPreview.svelte';
	import RecordingKeyPrompt from '../../CameraPlayer/RecordingKeyPrompt.svelte';
	import CameraCloudStoragePromoBanner from 'src/components/Settings/CameraCloudStorage/CameraCloudStoragePromoBanner.svelte';
	import { ensureDeviceKey, requestRecordingKey } from '../../helpers/recording-key-management';

	export let device: Device;

	let currentRecording = null;

	// Route the player's mid-stream key request to the single, shared prompt,
	// scoped to the recording's era via its `date`. A guest of a shared camera owns
	// no master key, so there is nothing to unlock.
	const handleRequireKey = (
		event: CustomEvent<{ deviceId: string; wrongKey: boolean; date?: string }>,
	) => {
		requestRecordingKey(event.detail?.deviceId, event.detail?.wrongKey, event.detail?.date);
	};

	// Resolve (or prompt for) the device key up-front whenever the device changes,
	// so playback already has the key and thumbnails can decrypt.
	$: if (device?.id && !device.shared) ensureDeviceKey(device.id);

	$: if (
		$routeToDeviceSettings[device.id]?.setting === 'camera_recordings' &&
		$routeToDeviceSettings[device.id]?.subSetting === 'view' &&
		$routeToDeviceSettings[device.id]?.params
	) {
		currentRecording = $routeToDeviceSettings[device.id].params;
		routeToDeviceSettings.resetTarget();
	}

	const handleSelected = (e) => {
		currentRecording = e.detail;
	};
</script>

<MediaPreview recording={currentRecording} on:requirekey={handleRequireKey} />
<!--
	The promo banner is placed ABOVE `CloudRecordings` because the
	underlying `RecordingsList` forces the sidepanel scroll parent to
	`overflow: hidden` and stretches itself to consume all remaining
	vertical space — anything rendered after it in DOM is clipped
	off-screen, so the banner would never be visible when the list has
	many items.
-->
<CameraCloudStoragePromoBanner addMarginTop deviceId={device?.id} />
<CloudRecordings selected={currentRecording} {device} on:select={handleSelected} />

<RecordingKeyPrompt {device} />
